import type { Glyph} from './font';
import { GLYPH_HEIGHT_IN_PIXELS, GLYPH_WIDTH_IN_PIXELS, getGlyph } from './font';
import type { PaintContext, YUV } from './paintContext';

export function drawText(
  paintContext: PaintContext,
  x: number, y: number,
  textColor: YUV, backgroundColor: YUV | undefined,
  text: string,
) {
  const lines = text.split('\n');
  for (let line = 0; line < lines.length; line++) {
    const Y = y + line * GLYPH_HEIGHT_IN_PIXELS;
    for (let i = 0; i < lines[line].length; i++) {
      const X = x + i * GLYPH_WIDTH_IN_PIXELS;
      const c = lines[line].charAt(i);
      const glyph = getGlyph(c);
      drawGlyph(paintContext, X, Y, textColor, backgroundColor, glyph);
    }
  }
}
function drawGlyph(
  paintContext: PaintContext,
  x: number, y: number,
  textColor: YUV, backgroundColor: YUV | undefined,
  glyph: Glyph,
) {
  for (let row = 0; row < GLYPH_HEIGHT_IN_PIXELS; row++) {
    for (let col = 0; col < GLYPH_WIDTH_IN_PIXELS; col++) {
      const drawPixel = glyph[row].charAt(col) === '@';
      if (drawPixel) {
        paintContext.setPixelYuv(x + col, y + row, textColor);
      } else if (backgroundColor) {
        paintContext.setPixelYuv(x + col, y + row, backgroundColor);
      }
    }
  }
}

